import $ from 'jquery';

$(document).ready(function () {
    $(".form-control").attr("placeholder", "€");
});